'use client'
import {usePathname, useRouter} from "next/navigation"
import React, {ReactNode, useEffect} from "react";
import {visitorLoginAsync, getUserInfoAsync, getUserInfoGameBaseAsync} from "@/app/userSliceAPI";
import {
    LoginType,
    selectUserInfo,
    SET_ACCESS_TOKEN,
    SET_TOKEN_EXPIRED,
    SET_USER_ID,
    SET_USER_LOGIN_TYPE,
} from "@/app/userSlice";
import Util from "@/Master/Util";
import {
    getLocalLogout,
    getLoginType,
    getToken,
    getTokenExpireTime,
    getUserId,
    removeAuthInfo
} from "@/app/utils/auth";
import {whiteList} from "@/app/config";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import Load from "@/app/_components/Load/Load";
import {hasTokenExpired} from "@/app/userSliceUtil";
import UnityGameDataManager from "@/app/(game)/game/UnityGameDataManager";
import {selectMainState} from "@/app/MainSlice";
import UtilUrl from "@/Core/UtilUrl";
import GameMgr from "@/app/(game)/GameMgr";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ForcedSignUpDialogFC} from "@/app/(pay)/UI/ForcedSignUpDialog/ForcedSignUpDialog";
import AuthTrack, {LoginScene} from "@/Core/AuthTrack";

export function UserProvider({children}: { children: ReactNode }) {
    const pathName = usePathname()
    const router = useRouter();
    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo);
    const {isDBok,isChannelOk} = useAppSelector(selectMainState);

    const onRouterChange = (path: string) => {
        // 在这里处理路由变化的逻辑
        if (Util.isLog) {
            console.log(`路由变化：${path}`);
        }
        const hasToken = getToken();
        const hasUserId = getUserId();
        const loginType = getLoginType();
        const expireTime = getTokenExpireTime();

        if (hasToken) {
            if (whiteList.includes(path)) {
                router.push('/')
            }

            dispatch(SET_ACCESS_TOKEN(hasToken))
            dispatch(SET_USER_ID(hasUserId))
            dispatch(SET_USER_LOGIN_TYPE(loginType))
            dispatch(SET_TOKEN_EXPIRED(expireTime))

            UnityGameDataManager.HandleUnityGameData(()=>{
                dispatch(getUserInfoAsync());
            });
        } else {
            if (!whiteList.includes(path)) {
                dispatch(visitorLoginAsync({}))
            }
        }
    };

    useEffect(() => {
        if (GameMgr.checkGamePath) return;
        // 判断是否登出
        if (getLocalLogout()) {
            router.push('/login?from=signOut');
            return;
        }
        // token过期跳转登录页
        if (hasTokenExpired()) {
            AuthTrack.showLogin(LoginScene.TokenExpired)
            removeAuthInfo()
            router.push('/login');
            // RouterMgr.login()
        }
        if (isChannelOk){
            onRouterChange(pathName)
        }
    }, [isChannelOk])

    useEffect(() => {
        if (GameMgr.checkGamePath) return;
        if (!Util.isWindow) {
            return;
        }

        if (!whiteList.includes(pathName)) {
            if (userInfo.loginType === LoginType.visitor) {
                if (userInfo.vipLevel > 0 || userInfo.vipExp > 0) {
                    // router.push('/signup/?from=payOk')
                    SDialogManagerFC.openDialog(ForcedSignUpDialogFC, {
                        fcKey: SDialogManagerFC.getFCKey(ForcedSignUpDialogFC),
                        isCloseBtn: false,
                    })
                    return;
                }
            }
        }
        const token = getToken();
        if (pathName == '/' && isChannelOk && token) {
            UnityGameDataManager.HandleUnityGameData(() => {
                dispatch(getUserInfoGameBaseAsync());
            });
        }
        if (Util.isLog) {
            console.log('路由变化2', pathName);
        }
    }, [pathName, isChannelOk]);

    useEffect(() => {
        if (GameMgr.checkGamePath) return;
        if (Util.isLog) {
            console.log(`用户信息已变更：`, userInfo)
        }
        if (userInfo.requestStatus === 'idle') {
            if (!userInfo.isGuide && pathName !== '/' && !whiteList.includes(pathName)) {
                router.push('/')
            }
            // 判断是否需要强制注册
            if (userInfo.loginType === LoginType.visitor) {
                if (userInfo.vipLevel > 0 || userInfo.vipExp > 0) {
                    SDialogManagerFC.openDialog(ForcedSignUpDialogFC, {
                        fcKey: SDialogManagerFC.getFCKey(ForcedSignUpDialogFC),
                        isCloseBtn: false,
                    })
                    return;
                }
            }
        }
    }, [userInfo])

    if (!userInfo.token
        && !whiteList.includes(pathName)
        && userInfo.requestStatus !== 'idle'
        && userInfo.firstRequestUserInfo
    ) return <Load />

    return (
         <>{children}</>
    )
}